
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'forecastKeyFiguresfilter',
    pure: false,
    standalone: false
})

export class FilterPipe implements PipeTransform {
  transform(items: any[], filter: Object): any { 
    if (!items || !filter) {
      return items;
    }
    console.log(items, "items");
    return items.filter(item => item.Visible);
  }
}